import { Box, Button, CircularProgress, Paper, TextField, Select, InputLabel, FormControl, MenuItem } from '@mui/material';
//import makeStyles from '@mui/styles/makeStyles';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GenericToolbar } from '../../components/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { ContentContainer } from '../../components/ContentContainer';
import { useSelectedOrganizationData, isRecordFound } from '../../hooks/data-hooks';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import locationStyles from './LocationStyle';
import { useDispatch, useSelector } from 'react-redux';
import { Actions, Thunks } from '../../actions';
import { useToasts } from '../../data/DataProviders/ToastProvider';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { EntityType, SiteRegistration } from '../../types/site';
import { Selectors } from '../../selectors';
import { isValidCharWithoutSpace } from '../../lib/site-helper';
//import STATE_LIST from '../../constants/state-list';
import { countries, states } from '../../constants/state-list';
import { HeaderInfo } from '../../components/HeaderInfo/HeaderInfo';
import { NavigationPromptModal } from '../../components/NavigationPromptModal/NavigationPromptModal';
//import { AnyARecord } from 'dns';


// const useStyles = makeStyles({
//     option: {
//         fontSize: 15,
//         '& > span': {
//             marginRight: 10,
//             fontSize: 18,
//         },
//     },
// });





export const AddLocation = (): JSX.Element => {
    const history = useHistory();
    const { t } = useLanguageLocale();
    const classes = locationStyles();
    //const classes1 = useStyles();
    const dispatch = useDispatch();
    const selectedOrganization = useSelectedOrganizationData();
    const { addToast } = useToasts();
    const authHelper = useAuthHelper();
    const orgId = isRecordFound(selectedOrganization) ? selectedOrganization.value.id : '';
    const orgName = isRecordFound(selectedOrganization) ? selectedOrganization.value.name : '';
    const [locationInfo, setLocationInfo] = useState<SiteRegistration | null>(null);
    const [unModifiedLocationInfo, setUnModifiedLocationInfo] = useState<SiteRegistration | null>(null);
    const [isDirty, setIsDirty] = useState(false);
    const userData = useSelector(Selectors.User.user);
    const siteState = useSelector(Selectors.Site.site);
    const [selectedCountry, setSelectedCountry] = React.useState<string>('');
    const [selectedState, setSelectedState] = React.useState<string>('');



    //   useEffect(() => {
    //     const newStates = body.filter(
    //       ({ country_name }) => country_name === selectedCountry
    //     );
    //     setState(newStates);
    //   }, [selectedCountry]);

    useEffect(() => {
        const locationData: SiteRegistration = {
            type: EntityType.Location,
            name: '',
            description: '',
            contact: `${userData.loggedInUser.user.fName} ${userData.loggedInUser.user.lName} ` || '',
            email: userData.loggedInUser.user.email || '',
            phone: userData.loggedInUser.user.phone || '',
            parentSiteId: orgId,
            siteAttributes: {
                address: '',
                city: '',
                country: '',
                state: '',
                zipCode: '',
            },
        };
        setUnModifiedLocationInfo(locationData);
        setLocationInfo(locationData);
    }, [userData, orgId]);

    useEffect(() => {
        if (!siteState.loading && siteState.success) {
            addToast('Location added successfully.');
            dispatch(Actions.Site.SiteRegistrationReset());
            dispatch(Thunks.Dashboard.locationRefresh(true));
            pushAppRoute(history, { type: 'LocationProfile', orgId: orgId, locationId: siteState.siteId });
        }
    }, [siteState]); //eslint-disable-line react-hooks/exhaustive-deps

    const isDisable = (): boolean => {
        const isEmpty =
            locationInfo &&
            (locationInfo.name.trim() === '' ||
                locationInfo.siteAttributes.address.trim() === '' ||
                locationInfo.siteAttributes.city.trim() === '' ||
                locationInfo.siteAttributes.country.trim() === '' ||
                locationInfo.siteAttributes.state.trim() === '' ||
                locationInfo.siteAttributes.zipCode.trim() === '' ||
                (selectedCountry === 'US' ? locationInfo.siteAttributes.zipCode.length !== 5 : locationInfo.siteAttributes.zipCode.length !== 6));
        return isEmpty || false;
    };
    useEffect(() => {
        const isModified = JSON.stringify(unModifiedLocationInfo) !== JSON.stringify(locationInfo);
        setIsDirty(isModified);
    }, [locationInfo, unModifiedLocationInfo]);

    const onSubmit = (): void => {
        if (locationInfo) {
            dispatch(Thunks.Site.createSiteRegistration(locationInfo, addToast, authHelper));
            dispatch(Thunks.Site.getExludedStateResponse(selectedState, selectedCountry, addToast, authHelper));
        }
    };
    const onChangeLocationName = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        modifiedlocationName: SiteRegistration
    ): void => {
        if (isValidCharWithoutSpace(e.target.value)) {
            const locationNameObj: SiteRegistration = { ...modifiedlocationName };
            locationNameObj.name = e.target.value;
            setLocationInfo(locationNameObj);
        }
    };
    const onChangeAddress = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        modifiedAddress: SiteRegistration
    ): void => {
        if (isValidCharWithoutSpace(e.target.value)) {
            const addressObj: SiteRegistration = { ...modifiedAddress };
            addressObj.siteAttributes.address = e.target.value;
            setLocationInfo(addressObj);
        }
    };
    const onChangeCity = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        modifiedCity: SiteRegistration
    ): void => {
        if (isValidCharWithoutSpace(e.target.value)) {
            const citysObj: SiteRegistration = { ...modifiedCity };
            citysObj.siteAttributes.city = e.target.value;
            setLocationInfo(citysObj);
        }
    };
    // const handleChangeState = (
    //     newValue: {
    //         label: string;
    //         value: string;
    //     } | null,
    //     modifiedState: SiteRegistration
    // ): void => {
    //     const stateObj: SiteRegistration = { ...modifiedState };
    //     stateObj.siteAttributes.state = newValue?.value || '';
    //     setLocationInfo(stateObj);
    // };
    const handleCountryChange = (
        event: any, modifiedState: SiteRegistration): void => {
        const country = event.target.value;
        const countryObj: SiteRegistration = { ...modifiedState };
        countryObj.siteAttributes.country = country || '';
        setLocationInfo(countryObj);
        setSelectedCountry(country);
        setSelectedState('');
        //setLocationInfo(country);
    };

    const handleStateChange = (event: any, modifiedState: SiteRegistration): void => {
        const state = event.target.value;
        const stateObj: SiteRegistration = { ...modifiedState };
        stateObj.siteAttributes.state = state || '';
        setLocationInfo(stateObj);
        setSelectedState(state);
    }

    const onChangeZipCode = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        modifiedZipCode: SiteRegistration
    ): void => {
        if (isValidCharWithoutSpace(e.target.value)) {
            const zipCodeObj: SiteRegistration = { ...modifiedZipCode };
            zipCodeObj.siteAttributes.zipCode = e.target.value;
            setLocationInfo(zipCodeObj);
        }
    };
    const onChangeNotes = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        modifiedNotes: SiteRegistration
    ): void => {
        if (isValidCharWithoutSpace(e.target.value)) {
            const notesObj: SiteRegistration = { ...modifiedNotes };
            notesObj.description = e.target.value;
            setLocationInfo(notesObj);
        }
    };
    const navigateToLocation = (): void => {
        pushAppRoute(history, { type: 'ManageLocation', orgId: orgId });
    };
    return (
        <>
            <GenericToolbar
                title={orgName}
                subtitle={'Add Location'}
                showBackButton
                backButtonOnClick={navigateToLocation}
            />
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
            />
            {isRecordFound(selectedOrganization) && locationInfo && (
                <ContentContainer>
                    <Paper style={{ padding: 48 }}>
                        <HeaderInfo title="Location Information" entity="to add a Location" />
                        <Box display="flex" flexDirection="column" alignItems="left">
                            <Box className={classes.paddingTextbox}>
                                <TextField
                                    inputProps={{ 'data-testid': 'location-name', maxLength: 100 }}
                                    fullWidth
                                    required
                                    variant="filled"
                                    id="location"
                                    label="Location Name"
                                    value={locationInfo.name}
                                    onChange={(e): void => onChangeLocationName(e, locationInfo)}
                                    helperText={
                                        <Box component="span" display="flex" justifyContent="flex-end">
                                            {locationInfo.name.length}/100
                                        </Box>
                                    }
                                />
                            </Box>
                            <Box className={`${classes.padding8} ${classes.paddingTop0} ${classes.paddingBottom24}`}>
                                <TextField
                                    inputProps={{ 'data-testid': 'Address', maxLength: 255 }}
                                    fullWidth
                                    required
                                    variant="filled"
                                    id="Address"
                                    label="Address"
                                    value={locationInfo.siteAttributes.address}
                                    onChange={(e): void => {
                                        onChangeAddress(e, locationInfo);
                                    }}
                                />
                            </Box>
                            <Box
                                className={`${classes.paddingTextbox}`}
                                display="flex"
                                justifyContent="space-between"
                                style={{ paddingBottom: 24 }}
                            >
                                <TextField
                                    inputProps={{ 'data-testid': 'city', maxLength: 100 }}
                                    style={{ width: '55%' }}
                                    required
                                    variant="filled"
                                    id="City"
                                    label="City"
                                    value={locationInfo.siteAttributes.city}
                                    onChange={(e): void => {
                                        onChangeCity(e, locationInfo);
                                    }}
                                />

                                <FormControl variant="filled" required>
                                    <InputLabel id="Data" data-testid="label" >
                                        Country
                                    </InputLabel>
                                    <Select
                                        label="Country"
                                        style={{ width: 400, padding: '0px 16px' }}
                                        required
                                        value={selectedCountry}
                                        onChange={(e): void => {
                                            handleCountryChange(e, locationInfo);
                                        }
                                        }



                                    >
                                        {countries.map((country) => (
                                            <MenuItem data-testid="country-menu" key={country.value} value={country.value}>
                                                {country.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Box>
                            <Box
                                className={`${classes.paddingTextbox}`}
                                display="flex"
                                justifyContent="space-between"
                                style={{ paddingBottom: 24 }}
                            >
                                {/* {selectedCountry &&( */}
                                <FormControl variant="filled" required>
                                    <InputLabel id="Data1" data-testid="label1" >
                                        State
                                    </InputLabel>
                                    <Select
                                        // label="State"
                                        style={{ width: 560, padding: '0px 16px' }}
                                        required
                                        value={selectedState}
                                        // onChange={handleStateChange}
                                        onChange={(e): void => {
                                            handleStateChange(e, locationInfo);
                                        }}
                                    >
                                        {selectedCountry && states[selectedCountry].map((state: any) => (
                                            //return (
                                            <MenuItem data-testid="state-menu" value={state.value} key={state.value}>
                                                {state.label}
                                            </MenuItem>
                                            //);
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* )} */}

                                <TextField
                                    inputProps={{ 'data-testid': 'zipCode', maxLength: selectedCountry === 'US' ? 5 : 6 }}
                                    style={{ width: '39%', margin: '0px 5px' }}
                                    required
                                    variant="filled"
                                    id="Zip Code"
                                    label="Zip Code"
                                    value={locationInfo.siteAttributes.zipCode}
                                    onChange={(e): void => {
                                        onChangeZipCode(e, locationInfo);
                                    }}
                                />
                            </Box>
                            <Box className={classes.paddingTextbox}>
                                <TextField
                                    inputProps={{ 'data-testid': 'notes', maxLength: 255 }}
                                    variant="filled"
                                    id="Notes"
                                    multiline
                                    maxRows={Infinity}
                                    label="Notes"
                                    fullWidth
                                    value={locationInfo.description}
                                    onChange={(e): void => {
                                        onChangeNotes(e, locationInfo);
                                    }}
                                    helperText={
                                        <Box component="span" display="flex" justifyContent="flex-end">
                                            {locationInfo.description.length}/255
                                        </Box>
                                    }
                                />
                            </Box>
                            <Box className={classes.iconRightEnd}>
                                <Button
                                    style={{ marginRight: 16 }}
                                    variant="outlined"
                                    color="primary"
                                    data-testid="cancel-location"
                                    onClick={navigateToLocation}
                                >
                                    {t('ACTIONS.CANCEL')}
                                </Button>
                                <Button
                                    startIcon={
                                        siteState.loading ? (
                                            <CircularProgress size="1rem" style={{ color: 'white' }} />
                                        ) : (
                                            <></>
                                        )
                                    }
                                    variant="contained"
                                    disabled={isDisable()}
                                    color="primary"
                                    data-testid="add-location-button"
                                    onClick={onSubmit}
                                >
                                    {t('ACTIONS.SUBMIT')}
                                </Button>
                            </Box>
                        </Box>
                    </Paper>
                </ContentContainer>
            )}
            {isDirty && !siteState.success && <NavigationPromptModal isDirty={isDirty} />}
        </>
    );
};